import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { ContinuousSpinner } from 'src/App/Components/Loaders/ContinousSpinnerCard';
import { COLOR_BACKGROUND_2 } from 'src/colors';

const DynamicDataCardLoading = ({}) => {
  return (
    <div
      style={{
        height: '75px',
        width: '150px',
        backgroundColor: COLOR_BACKGROUND_2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '10px',
        padding:"10px 20px"
      }}
    >
      <ContinuousSpinner />
      <p style={{ fontSize: '20px', fontFamily:'"Roboto", "Helvetica", "Arial"' }}>Loading...</p>
    </div>
  );
};

export default DynamicDataCardLoading;
